export default "__VITE_ASSET__BjDHHCNC__"